(function () {
  const HTML = document.documentElement;

  const FACET_MODEL = "Modell";
  const FACET_COLOR = "Farbe";

  /* ---------------------------------------------------
     Utilities
  --------------------------------------------------- */

  function getFacetDetails(label) {
    return (
      document.querySelector(`details[data-hsp-facet="${label}"]`) ||
      [...document.querySelectorAll("details[data-hsp-facet]")].find((d) =>
        (d.getAttribute("data-hsp-facet") || "")
          .trim()
          .toLowerCase()
          .includes(label.toLowerCase())
      ) ||
      null
    );
  }

  function keepColorOpen() {
    const color = getFacetDetails(FACET_COLOR);
    if (color) color.setAttribute("open", "");
  }

  function isBrandActiveByUrl() {
    const params = new URLSearchParams(window.location.search);

    const commonKeys = [
      "filter.p.vendor",
      "filter.v.option.vendor",
      "filter.v.option.brand",
      "filter.v.option.marke",
      "filter.p.m.custom.brand",
      "filter.p.m.custom.marke",
    ];

    for (const key of commonKeys) {
      if (params.has(key)) return true;
    }

    for (const key of params.keys()) {
      const k = key.toLowerCase();
      const isBrand =
        k.includes("vendor") ||
        k.includes("brand") ||
        k.includes("marke");
      const isExcluded =
        k.includes("modell") ||
        k.includes("model") ||
        k.includes("farbe") ||
        k.includes("color");

      if (isBrand && !isExcluded) return true;
    }

    return false;
  }

  function pruneModelOptions() {
    const model = getFacetDetails(FACET_MODEL);
    if (!model) return;

    const items = model.querySelectorAll(
      "li.facets__item, li.list-menu__item"
    );

    items.forEach((li) => {
      const disabled = li.querySelector(
        'input[type="checkbox"][disabled]'
      );
      li.style.display = disabled ? "none" : "";
    });
  }

  /* ---------------------------------------------------
     Stable Visibility Control (No Flicker, No Jump)
  --------------------------------------------------- */

  function setModelVisibility(isBrandSelected) {
    // Block interaction during transition
    HTML.classList.add("hsp-model-loading");

    if (isBrandSelected) {
      HTML.classList.add("hsp-show-model");
    } else {
      HTML.classList.remove("hsp-show-model");
    }

    // Wait for Shopify DOM redraw
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        HTML.classList.add("hsp-model-ready");
        HTML.classList.remove("hsp-model-loading");

        const model = getFacetDetails(FACET_MODEL);
        if (model && isBrandSelected) {
          model.setAttribute("open", "");
          pruneModelOptions();
        }
      });
    });
  }

  /* ---------------------------------------------------
     State Application
  --------------------------------------------------- */

  function applyState() {
    keepColorOpen();
    const brandActive = isBrandActiveByUrl();
    setModelVisibility(brandActive);
  }

  /* ---------------------------------------------------
     Event Binding
  --------------------------------------------------- */

  let stableTimer = null;

  function scheduleUpdate() {
    clearTimeout(stableTimer);
    stableTimer = setTimeout(() => {
      applyState();
    }, 180);
  }

  function bind() {
    applyState();

    // Very early capture to prevent mobile tap jump
    document.addEventListener(
      "pointerdown",
      (e) => {
        if (!e.target) return;
        if (e.target.closest("details[data-hsp-facet]")) {
          scheduleUpdate();
        }
      },
      true
    );

    document.addEventListener("change", (e) => {
      if (!e.target) return;
      if (
        e.target.closest("#FacetFiltersForm") ||
        e.target.closest("facet-filters-form")
      ) {
        scheduleUpdate();
      }
    });

    // Shopify AJAX re-render observer
    new MutationObserver(() => {
      scheduleUpdate();
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("popstate", scheduleUpdate);
  }

  document.addEventListener("DOMContentLoaded", bind);
})();